import moment from "moment";

export const toBuddhistYear = (date) => date.getFullYear() + 543;

export const formatDateBE = (date, inputFormat) => {
  if (!date) return "";
  const d = inputFormat ? moment(date, inputFormat, true) : moment(date);
  if (!d.isValid()) return "";
  return `${d.format("DD/MM")}/${d.year() + 543}`;
};

const THAI_MONTHS = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

export const formatPrintDateTimeBE = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  const day = date.getDate();
  const month = THAI_MONTHS[date.getMonth()];
  const year = toBuddhistYear(date);
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `วันที่พิมพ์เอกสาร: ${day} ${month} ${year} เวลา ${hours}:${minutes} น.`;
};

export const buildPdfFooterBE = (printedAt) => () => ({
  text: formatPrintDateTimeBE(printedAt),
  alignment: "right",
  fontSize: 10,
  margin: [0, 5, 30, 0],
});
